// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__jEddW","item":"PaymentsMobile_item__6DCmt","label":"PaymentsMobile_label__1Ny7x","amount":"PaymentsMobile_amount__2CFvw"};